import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { SelectItem } from 'primeng/components/common/api';
import { Company } from '../../../models/company.model';
import { UserApplication } from '../../../models/user.model';
import { DataTableCustomButton } from '../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { CalendarTranslateService } from '../../../modules/UIKit/services/calendarTranslate.service';
import { CompaniesService } from '../../../services/company/companies.service';
import { UsersService } from '../../../services/user/users.service';

@Component({
    selector: 'app-user-companies-form',
    templateUrl: './userCompaniesForm.component.html',
    styles: ['label.required:after {top: 0}']
})

export class UserCompaniesFormComponent implements OnChanges, OnInit {

    @Output() companiesAdded: EventEmitter<any> = new EventEmitter<any>();
    @Output() companiesUpdated: EventEmitter<any> = new EventEmitter<any>();
    @Input() dialogBox;

    selectedCompany: Company = null;
    selectedApplications: UserApplication[] = [];
    companies: SelectItem[]  = [{ value: null, label: '' }];
    form: FormGroup;
    minDate: Date;
    customButtons: DataTableCustomButton[];
    newDataAvailable = false;
    btntraduction = 'common.add';
    invalidSubmit: boolean;
    fields: any;

    public maxDate: Date = new Date();
    dateStartIssue = false;
    dateEndIssue = false;
    dateStartMax = null;
    dateEndMin = null;

    constructor (
        private fb: FormBuilder,
        private srvTranslate: TranslateService,
        private srvCompany: CompaniesService,
        protected srvCalTranslate: CalendarTranslateService,
        private srvUsers: UsersService
    ) {
    }

    ngOnInit(): void {

      this.srvUsers.getCompanyFields().subscribe(res => this.fields = res);

      this.srvCompany.getAll().subscribe((data) => {
        data.forEach((c) => {
            this.companies.push({ value: c.id, label: c.name });
        });
        this.form.controls['company_id'].setValue(this.dialogBox.company_id);
      });
      if (this.dialogBox.id != null) {
        this.btntraduction = 'common.edit';
      }
    }

    ngOnChanges(changes) {
      this.form = this.fb.group({
        'company_id': new FormControl(this.dialogBox.company_id),
        'date_start': new FormControl(this.dialogBox.date_start),
        'date_end': new FormControl(this.dialogBox.date_end)
      });
    }

    saveOrUpdate(): void {
      if (!this.form.valid) {
        this.invalidSubmit = true;
        return;
      }
      this.invalidSubmit = false;
        let newData = Object.assign({}, this.dialogBox, this.form.value);
        newData.name = this.companies.find((e) => {return (e.value === this.form.value.company_id)}).label;
        newData.date_start = moment(newData.date_start).format('YYYY-MM-DD');
        newData.date_end = moment(newData.date_end).format('YYYY-MM-DD');
        if (newData.id == null) {
          this.companiesAdded.emit(newData);
        } else {
          this.companiesUpdated.emit(newData);
        }
    }

    setDefaultDateStart() {
      if (!!this.form.controls.date_start.value) {
        return this.form.controls.date_start.value;
      } else {
        return null;
      }
    }

    setDefaultDateEnd() {
      if (!!this.form.controls.date_end.value) {
        return this.form.controls.date_end.value;
      } else {
        return null;
      }
    }

}




// WEBPACK FOOTER //
// ./src/app/views/administration/users/userCompaniesForm.component.ts